import React from "react";
import { Container, Typography, Box, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useBrand } from "../brand/BrandContext";
import TenantLegalNotice from "../components/TenantLegalNotice";
import LegalPageBody from "../components/LegalPageBody";

const TermsAndConditions = () => {
  const { t } = useTranslation("common");
  const brand = useBrand();

  const defaultBody = (
    <>
      <Typography variant="body2" color="textSecondary" gutterBottom textAlign="center">
        {t("termsAndConditions.lastUpdated")}
      </Typography>

      <Box mt={5}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("termsAndConditions.s1Title")}</Typography>
        <Typography paragraph>{t("termsAndConditions.s1P1")}</Typography>
        <Typography paragraph>
          {t("termsAndConditions.s1P2")}<Link href="/offer" underline="hover">{t("termsAndConditions.s1P2Link")}</Link>.
        </Typography>
      </Box>

      <Box mt={5}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("termsAndConditions.s2Title")}</Typography>
        <Typography paragraph>{t("termsAndConditions.s2P1")}</Typography>
      </Box>

      <Box mt={5}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("termsAndConditions.s3Title")}</Typography>
        <Typography paragraph sx={{ whiteSpace: "pre-line" }}>{t("termsAndConditions.s3P1")}</Typography>
      </Box>

      <Box mt={5}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("termsAndConditions.s4Title")}</Typography>
        <Typography paragraph>{t("termsAndConditions.s4P1")}</Typography>
        <Typography paragraph>{t("termsAndConditions.s4P2")}</Typography>
      </Box>

      <Box mt={5}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("termsAndConditions.s5Title")}</Typography>
        <Typography paragraph sx={{ whiteSpace: "pre-line" }}>{t("termsAndConditions.s5P1")}</Typography>
        <Typography paragraph>{t("termsAndConditions.s5P2")}</Typography>
      </Box>

      <Box mt={5}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("termsAndConditions.s6Title")}</Typography>
        <Typography paragraph>{t("termsAndConditions.s6P1")}</Typography>
        <Typography paragraph>{t("termsAndConditions.s6P2")}</Typography>
      </Box>

      <Box mt={5}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("termsAndConditions.s7Title")}</Typography>
        <Typography paragraph sx={{ whiteSpace: "pre-line" }}>{t("termsAndConditions.s7P1")}</Typography>
      </Box>
    </>
  );

  return (
    <Container maxWidth="md" sx={{ mt: 2, mb: 2, py: 6, backgroundColor: "#fff", px: { xs: 2, sm: 4 }, borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom textAlign="center" sx={{ fontWeight: "bold", mb: 4 }}>
        {t("termsAndConditions.title")}
      </Typography>

      <TenantLegalNotice />

      <LegalPageBody customBody={brand.legalPages?.terms}>
        {defaultBody}
      </LegalPageBody>
    </Container>
  );
};

export default TermsAndConditions;
